/**
 * Created by User on 28/3/2560.
 */
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard {
   taskid: any;
   device: string;

   constructor(private router: Router) {}

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      let url;
      if (window.location.pathname !== undefined) {
         url = window.location.pathname.replace('/idex', '');
         if (url.startsWith('/signdoc/')) {
            this.taskid = url.replace('/signdoc/', '').split('/')[0];
            this.device = url.replace('/signdoc/', '').split('/')[1];
         }
      }

      if (localStorage.getItem('idex-user')) {
         const user = JSON.parse(localStorage.getItem('idex-user'));
         if (!user['role'] && user.business) {
            for (const b of user.business) {
               user['role'] = b.role;
            }
         }
         if (state.url.startsWith('/company-list') || state.url.startsWith('/admin-tool')) {
            if (user.role !== 'IT Support' && user.role !== 'Admin') {
               this.router.navigate(['/']);
               return false;
            }
         }
         return true;
      }

      if (this.taskid !== undefined) {
         this.checkDevice('signdoc', this.taskid);
      } else {
         if (url !== undefined && url.startsWith('/file/')) {
            const docId = url.replace('/file/', '').split('/')[0];
            this.checkDevice('file', docId);
         } else if (url !== undefined && url.startsWith('/share/')) {
            const shareId = url.replace('/share/', '').split('/')[0];
            this.router.navigate(['/login', 'share', shareId]);
         } else {
            this.router.navigate(['/login']);
         }
      }
      return false;
   }

   checkDevice(path, id) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search('iphone') > -1 && this.device !== 'web') {
         window.location.href = `idex://${path}?key=${id}`;
         setTimeout(function () {
            window.location.href = 'https://itunes.apple.com/app/zdox/id1436468541';
         }, 5000);
      } else if (userAgent.search('android') > -1 && this.device !== 'web') {
         window.location.href = `idex://${path}?key=${id}`;
         setTimeout(function () {
            window.location.href = `https://play.google.com/store/apps/details?id=com.ginkgosoft.idex&referrer=${path}?key=${id}`;
         }, 1000);
      } else {
         this.router.navigate(['/login', path, id]);
      }
   }
}
